import { useSelector } from 'react-redux';
import { getMethodAuthData } from 'selectors/methodAuth';
import { FlowComponentType } from 'routes/types';
import { ErrorType as MethodErrorType } from 'api/MethodApi';
import { ApplyingResult as Result } from 'enums/FlowNextResults';
import { RoutePath } from 'enums/Routes';

import { useNavigate } from './useNavigate';

const useMethodAuth = () => {
  const navigate = useNavigate();
  const { failed: methodAuthFailed, errorType: methodErrorType, entityId } = useSelector(getMethodAuthData);

  const processMethodErrorAndRedirect = (
    handleNext: FlowComponentType['handleNext'],
    errorType?: MethodErrorType,
    withAddressRedirect = true,
    defaultAuthFailed?: boolean,
    currentEntityId?: string,
  ): boolean => {
    if (defaultAuthFailed ?? methodAuthFailed) {
      switch (errorType ?? methodErrorType) {
        case MethodErrorType.UnauthorizedSessionToken:
          handleNext(Result.SessionExpired);
          return true;
        case MethodErrorType.InvalidZipCode:
          if (withAddressRedirect) navigate(RoutePath.YourAddress);
          return true;
        default:
          // If we get an error creating the auth session, but we already have an entityId we can continue
          if (!currentEntityId && !entityId) {
            handleNext(Result.Error);
            return true;
          }
          break;
      }
    }

    return false;
  };

  return { processMethodErrorAndRedirect };
};

export default useMethodAuth;
